import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { isPromoActive } from '@/lib/promo';

const STORAGE_KEY = 'zofia-promo-popup-dismissed-v1';

const PromoPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isPromoActive()) return;
    if (typeof window === 'undefined') return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    const timer = window.setTimeout(() => setOpen(true), 2200);
    return () => window.clearTimeout(timer);
  }, []);

  const close = () => {
    setOpen(false);
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {}
  };

  if (!isPromoActive()) return null;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[80] flex items-center justify-center p-4 md:p-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          {/* Backdrop */}
          <button
            aria-label="Chiudi popup promo"
            onClick={close}
            className="absolute inset-0 bg-background/70 backdrop-blur-sm"
          />

          <motion.div
            role="dialog"
            aria-labelledby="promo-popup-title"
            aria-modal="true"
            className="relative w-full max-w-lg rounded-2xl border border-gold/30 bg-gradient-to-br from-navy/95 to-background/95 shadow-[0_20px_60px_-10px_hsl(42_50%_59%/0.25)] overflow-hidden"
            initial={{ opacity: 0, y: 30, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.96 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          >
            {/* Gold hairline */}
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" />

            <button
              onClick={close}
              aria-label="Chiudi"
              className="absolute top-3 right-3 w-9 h-9 rounded-full flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-foreground/5 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>

            <div className="p-7 md:p-9">
              <p className="text-gold uppercase tracking-[0.22em] text-[11px] font-semibold mb-4">
                Promo · valida fino al 31 luglio
              </p>

              <h2
                id="promo-popup-title"
                className="font-serif text-2xl md:text-3xl leading-tight text-foreground mb-3"
              >
                Due occasioni esclusive per portare online la tua attività.
              </h2>

              <div className="text-muted-foreground text-sm md:text-base leading-relaxed mb-6 space-y-3">
                <p>
                  <span className="text-foreground/90 font-medium">Molise Online</span> — sconti fino al 30% per attività turistiche in Molise e Abruzzo.
                </p>
                <p>
                  <span className="text-foreground/90 font-medium">Permuta Sito</span> — nuovo sito vetrina a partire da €790, consegna in 7 giorni.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/promozioni"
                  onClick={close}
                  className="btn-premium text-sm flex-1 text-center"
                >
                  <span>Scopri le promo</span>
                </Link>
                <button
                  onClick={close}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors px-4 py-2"
                >
                  Non ora
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PromoPopup;
